import { render, staticRenderFns } from "./BrandUpdatePage.vue?vue&type=template&id=061650ef&scoped=true"
import script from "./BrandUpdatePage.vue?vue&type=script&lang=js"
export * from "./BrandUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./BrandUpdatePage.vue?vue&type=style&index=0&id=061650ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061650ef",
  null
  
)

export default component.exports